import { useState } from 'react';
import { automationUpdateApi, deleteAutomationAPI } from '../api/automation';
import { download } from '../common/DownloadFileController/downloadFile';
import { MODEL_TYPES } from '../constants/constants';
import { apiGetDownloadAutomation } from '../helpers/api';
import { errorToast } from '../helpers/toastHelper';
import { paginatedAutomationSelectors } from '../redux/slicers/admin/paginatedAutomation';
import { useModelActions } from './useModelActions';

export const useAutomationActions = ({ item }) => {
  const { downloadAutomation, downloadLoading } = useDownloadAutomation();

  const deleteTitle = item.is_main_render
    ? 'Are you sure you want to archive this automation?'
    : 'Are you sure you want to delete this automation?';

  const deleteDescription = item.is_main_render
    ? 'You can view the archived automation through filter panel.'
    : 'Deleted items will be moved to trash.';

  const cancelButtonText = item.is_main_render ? 'Cancel' : 'Cancel';
  const okButtonText = item.is_main_render ? 'Archive' : 'Delete';
  const okBtnColor = 'warning';
  const cancelBtnColor = 'secondary';
  const okBtnClassName = item.is_main_render ? 'lf-btn-3' : undefined;
  const deleteSuccessMessage = item.is_main_render
    ? 'Archived successfully'
    : 'Deleted successfully';

  const { favouriteLoading, onFavouriteToggle, onDelete, addToCollection } = useModelActions({
    item,
    modelType: MODEL_TYPES.AUTOMATION,
    selectors: paginatedAutomationSelectors,
    updateApi: automationUpdateApi,
    deleteSuccessMessage: deleteSuccessMessage,
    deleteConfig: {
      deleteApi: deleteAutomationAPI,
      title: deleteTitle,
      description: deleteDescription,
      cancelButtonText,
      buttonText: okButtonText,
      okBtnColor,
      cancelBtnColor,
      okBtnClassName,
    },
  });

  return {
    onDelete,
    onFavouriteToggle,
    favouriteLoading,
    downloadAutomation,
    downloadLoading,
    addToCollection,
  };
};

export const useDownloadAutomation = () => {
  const [loading, setLoading] = useState(false);

  const downloadAutomation = async (idOrList) => {
    if (loading) return;

    setLoading(true);
    await downloadAutomationFile(idOrList);
    setLoading(false);
  };

  return { downloadAutomation, downloadLoading: loading };
};

const downloadAutomationFile = async (idOrList) => {
  const formData = new FormData();

  if (Array.isArray(idOrList)) {
    idOrList.forEach((id) => {
      formData.append('id', id);
    });
  } else {
    formData.append('id', idOrList);
  }
  const res = await apiGetDownloadAutomation(formData);
  if (res.status) {
    res?.data?.results?.map((item) => {
      download({
        fileUrl: item.zip_url,
        fileName: `${item.name}.zip`,
      });
    });
  } else {
    errorToast(res?.message);
  }
};
